var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title + ' - ' + _vm.organizationName),expression:"$route.meta.title + ' - ' + organizationName"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }